import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="min-h-screen bg-brand-darkBg text-slate-200 selection:bg-brand-blue selection:text-white font-sans" data-id="element-0">
      <main className="overflow-hidden" data-id="element-1">
        <Hero data-id="element-2" />
        <Stats data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ProductSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <PurchaseNotification data-id="element-10" />
    </div>;
}